module.exports = __webpack_public_path__ + "img/pin-start.a746e545.png";